import type { TicketStatus, TicketCategory } from './types';

export const STATUS_DOT_COLORS: Record<TicketStatus, string> = {
  NEW: 'var(--status-new)',
  PROCESSING: 'var(--status-processing)',
  OPEN: 'var(--status-open)',
  RESOLVED: 'var(--status-resolved)',
  CLOSED: 'var(--status-closed)',
};

export const STATUS_TEXT_COLORS: Record<TicketStatus, string> = {
  NEW: 'var(--status-new)',
  PROCESSING: 'var(--status-processing)',
  OPEN: 'var(--status-open)',
  RESOLVED: 'var(--status-resolved)',
  CLOSED: 'var(--status-closed)',
};

export const STATUS_STYLES: Record<TicketStatus, string> = {
  NEW: 'text-violet-400',
  PROCESSING: 'text-amber-400',
  OPEN: 'text-sky-400',
  RESOLVED: 'text-emerald-400',
  CLOSED: 'text-zinc-500',
};

export const STATUS_LABELS: Record<TicketStatus, string> = {
  NEW: 'New',
  PROCESSING: 'Processing',
  OPEN: 'Open',
  RESOLVED: 'Resolved',
  CLOSED: 'Closed',
};

export const CATEGORY_LABELS: Record<TicketCategory, string> = {
  GENERAL_QUESTION: 'General',
  TECHNICAL_QUESTION: 'Technical',
  REFUND_REQUEST: 'Refund',
};

export const ALL_STATUSES: TicketStatus[] = ['OPEN', 'RESOLVED', 'CLOSED'];
export const ALL_CATEGORIES: TicketCategory[] = [
  'GENERAL_QUESTION',
  'TECHNICAL_QUESTION',
  'REFUND_REQUEST',
];

export const UNCATEGORIZED = '__none__';
export const UNASSIGNED = '';
